export default __webpack_public_path__ + "static/media/Vector2.ed221593.svg";